import { fetchCompletenessGeneralRevenue, fetchDelayedStores } from 'home/actions'
import { moment } from 'locale'
import { connect } from 'react-redux'
import { fetchCountryStoresList } from 'revenue/actions'
import type { State } from 'store/types'
import { getMomentDate } from 'utils/dateUtils'

import { closeChannelDetails, fetchClosedReportingOnlyStores, setSelectedValue, showChannelDetails } from './actions'
import CompletenessDetails from './CompletenessDetails'

const mapStateToProps = ({ completeness, componentsCompleteness, datePicker }: State) => ({
  countryId: componentsCompleteness.channelDetails && componentsCompleteness.channelDetails.countryId,
  countryName: (componentsCompleteness.channelDetails || {}).countryNamePL,
  dateCurrent: getMomentDate(datePicker.dateCurrent).format('L'),
  delayedStores: completeness.delayedStores,
  selectedValue: componentsCompleteness.selectedValue,
  todayDateChosen: moment().isSame(getMomentDate(datePicker.dateCurrent), 'day'),
})

export default connect(mapStateToProps, {
  closeChannelDetails,
  fetchClosedReportingOnlyStores,
  fetchCompletenessGeneralRevenue,
  fetchCountryStoresList,
  fetchDelayedStores,
  setSelectedValue,
  showChannelDetails,
})(CompletenessDetails as any) as any
